import script from "./ArchivedRuleModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArchivedRuleModal.vue?vue&type=script&setup=true&lang=ts"

import "./ArchivedRuleModal.vue?vue&type=style&index=0&id=1329ac44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1329ac44"]])

export default __exports__